import { reactive } from 'vue';

export const criarManutPlano = () => {
    return reactive({
        id: 0,
        idmunicipio: 0,
        idequipamentogrupo: 0,
        idequipamento: 0,
        cdplano: 0,
        nmplano: '',
        obs: '',
        ativo: 'S',
        idlogin: 0
    });
}